import { Interp } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Toast({ v }) {
  if (!v.hasToast) return null;
  return (
    <>
      <div style={{ "position": "fixed", "left": "50%", "top": "86px", "transform": "translateX(-50%)", "zIndex": "100", "display": "flex", "alignItems": "center", "gap": "10px", "background": "#fff", "border": "3px solid var(--ink)", "borderRadius": "16px", "boxShadow": "4px 4px 0 var(--ink)", "padding": "11px 15px", "maxWidth": "min(460px,90vw)", "animation": "gpToastIn .3s cubic-bezier(.22,1.3,.4,1) both" }}>
        {v.hasToastAvatar ? (<>
          <span style={{ "position": "relative", "flex": "0 0 auto", "display": "block" }}>
            {' '}
            <img alt="" src={v.toastAvatar} style={{ "width": "34px", "height": "34px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block" }} />
            {' '}
            <span style={{ "position": "absolute", "right": "-5px", "bottom": "-5px", "width": "13px", "height": "13px", "borderRadius": "50%", "background": "var(--groen)", "border": "3px solid var(--ink)" }} />
            {' '}
          </span>
        </>) : null}
        {v.noToastAvatar ? (<>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--roze)" strokeWidth="2.9" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>
        </>) : null}
        <span style={{ "fontSize": "13px", "fontWeight": "600", "lineHeight": "1.4" }}>
          <Interp v={v.toast} />
        </span>
        <button onClick={v.hideToast} title="Sluiten" style={{ "border": "none", "background": "transparent", "cursor": "pointer", "color": "var(--ink)", "display": "flex", "padding": "4px", "borderRadius": "8px", "flex": "0 0 auto" }}>
          <Kruis maat={16} />
        </button>
      </div>
    </>
  );
}
